import {camelCase} from 'lodash';

const FilenameMixin = {
  methods: {
    getSafeFilename(name) {
      if (!name) return '';
      return `${camelCase(name)}.js`;
    },
    isValidFilename(name) {
      return /^[a-zA-Z0-9./]+$/.test(name);
    }
  },
  data() {
    return {};
  }
};
export default FilenameMixin;
